module.exports = __webpack_public_path__ + "static/img/benchibaoma.bbfa95f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/benchibaoma.jpg
// module id = 4Fbv
// module chunks = 0